module.exports = __webpack_public_path__ + "files/400ab808e8b3ba053d41d8dc72ea3aff.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600.svg
// module id = 1149
// module chunks = 76